import { useCallback } from "react";
import { usePostHog } from "posthog-js/react";
import { getEnvPublic, isProductionEnvironment } from "@remi/environment";
import type { NextEvent, NextEventProperties } from "@remi/types/posthog";

export function useAnalytics() {
  const posthog = usePostHog();

  const capturePosthogEvent = useCallback(
    <E extends NextEvent>(event: E, properties?: NextEventProperties[E]) => {
      if (isProductionEnvironment() || getEnvPublic("NEXT_PUBLIC_POSTHOG_PREVIEW_ENABLED")) {
        posthog.capture(event, properties);
      }
    },
    [posthog],
  );

  return { capturePosthogEvent };
}
